import { createSlice } from "@reduxjs/toolkit";
import { getAllUsers, getCurrentUser } from "../../controller/users/usersController";
import errorHandler from "../../utils/errorHandler";

const initialState = {
    isLoading: false,
    isSuccess: false,
    listOfUsers: [],
    currentUser: {},
    length: 0
}

const usersSlice = createSlice({
    name: 'users',
    initialState,
    extraReducers: {
        [getAllUsers.pending]: (state) => {
            state.isLoading = true;
        },
        [getAllUsers.fulfilled]: (state, { payload }) => {
            const { success, data, count } = payload;
            state.isLoading = false;
            state.isSuccess = success;
            state.listOfUsers = data;
            state.length = count;
        },
        [getAllUsers.rejected]: (state, { payload }) => {
            state.isLoading = false;
            errorHandler(payload);
        },
        [getCurrentUser.pending]: (state, { payload }) => {
            state.isLoading = true;
            state.currentUser = {};
        },
        [getCurrentUser.fulfilled]: (state, { payload }) => {
            const { success, data } = payload;
            state.isLoading = false;
            state.isSuccess = success;
            state.currentUser = data;
        },
        [getCurrentUser.rejected]: (state, { payload }) => {
            state.isLoading = false;
            errorHandler(payload);
        }
    }
});

export default usersSlice.reducer;